import React, { Component } from "react";
import { Input } from "antd";

import moment from "moment";
import DatetimeRangePicker from "new-bootstrap-datetimerangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { defaultDateFormat } from "../lib/util";
import { DateRange, Cancel } from "@material-ui/icons";
import { COLORS } from "../pages/theme";

class CustomDateRangePicker extends Component {
  constructor(props) {
    super(props);
    this.handleEvent = this.handleEvent.bind(this);
    this.state = {
      startDate: null, // moment().subtract(6, 'days'),
      endDate: null, //moment(),
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "Last 60 Days": [moment().subtract(59, "days"), moment()],
        "Last 180 Days": [moment().subtract(179, "days"), moment()],
        "Last 365 Days": [moment().subtract(364, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
    };
  }
  handleEvent(event, picker) {
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;

    console.log("dates", picker);
    // Do not send any change to parent for same daterange picked
    // if(picker.startDate!=startDate && picker.endDate!=endDate && picker.isShowing){
    this.setState(
      {
        startDate: picker.startDate,
        endDate: picker.endDate,
      },
      () => {
        typeof this.props.onChange === "function" &&
          this.props.onChange(picker);
      }
    );
    // }
  }

  render() {
    let dateFormat = this.props.dateFormat || defaultDateFormat;
    let start = this.state.startDate
      ? this.state.startDate.format(dateFormat)
      : null;
    let end = this.state.endDate ? this.state.endDate.format(dateFormat) : null;
    let label = start + " - " + end;
    if (start === end) {
      label = start;
    }
    if (label == " - ") {
      label = null;
    }

    // ASSIGNING CUSTOM LABEL FOR FIXED DATE
    if (start && end && this.props.excludeRanges == false) {
      Object.keys(this.state.ranges).map((key) => {
        let range = this.state.ranges[key];
        // console.log("RANGE",range)
        if (
          range[0].format(dateFormat) == start &&
          range[1].format(dateFormat) == end
        ) {
          label = key;
        }
      });
    }

    let buttonStyle = {
      width: "100%",
      flex: 1,
      position: "relative",
      ...this.props.style,
    };
    return (
      <DatetimeRangePicker
        style={buttonStyle}
        showDropdowns
        isCustomDate
        disabled={true}
        showCustomRangeLabel={false}
        linkedCalendars={false}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        ranges={this.props.excludeRanges ? undefined : this.state.ranges}
        dateLimit={this.props.dateLimit}
        onApply={this.handleEvent}
        // onEvent={this.handleEvent}
        opens="right"
      >
        {start && end && this.props.allowClear && (
          <Cancel
            onClick={(e) => {
              console.log("clear clicked");
              e.preventDefault();
              e.stopPropagation();
              this.handleEvent(null, {});
            }}
            className="star-inactive"
            style={{
              height: 20,
              color: "rgba(0, 0, 0, 0.25)",
              zIndex: 2,
              position: "absolute",
              right: 0,
              top: "50%",
              transform: `translate(-11px, -50%)`,
              // translate:''
            }}
          />
        )}
        <Input
          // allowClear={start&&end}
          value={label}
          placeholder="Select Date Range"
          suffix={
            start && end && this.props.allowClear ? null : (
              // <Cancel
              // onClick={(e)=>{
              //   console.log("clear clicked")
              //   e.preventDefault();
              //   e.stopPropagation();
              //   this.handleEvent(null,{})

              // }}
              // className='star-inactive'
              // style={{
              //   height:20,
              //   color:'rgba(0, 0, 0, 0.25)',
              //   zIndex:2,
              // }}/>
              <DateRange
                className="star-inactive"
                style={{
                  height: 20,
                  color: "rgba(0, 0, 0, 0.25)",
                }}
              />
            )
          }
          // onChange={(e)=>{
          //   console.log("change",e.target.value)
          // }}
          // className="selected-date-range-btn"
          style={{
            backgroundColor: "transparent",
            // fontSize:20
          }}
        >
          {/* <div className="pull-left">
                <i className="fa fa-calendar"/>
                &nbsp;
                <span>
                  {label}
                </span>
              </div>
              <div className="pull-right">
                <i className="fa fa-angle-down"/>
              </div> */}
        </Input>
      </DatetimeRangePicker>
    );
  }

  componentDidMount = () => {
    this.setState({
      startDate: this.props.startDate,
      endDate: this.props.endDate,
    });
  };

  componentDidUpdate = (prevProps) => {
    if (
      this.props.startDate !== prevProps.startDate ||
      this.props.endDate !== prevProps.endDate
    ) {
      this.setState({
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      });
    }
  };
}

CustomDateRangePicker.defaultProps = {
  startDate: moment().subtract(6, "days"),
  endDate: moment(),
  excludeRanges: false,
  dateLimit: undefined,
};

export default CustomDateRangePicker;
